module.exports = __webpack_public_path__ + "static/img/home_cpjfw_fwal.56d2fbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_cpjfw_fwal.png
// module id = 2VL3
// module chunks = 21